/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/modal/modal.interface.ts"/>
///<reference path="../../../components/models/meevo.model.custom.ts"/>

module Meevo.Components.Controls {

    export interface ISwitchButton {
        displayName: string;
        key: string | number;
    }

    class MeevoButtonSwitch implements angular.IComponentController {
        model: string;
        isDisabled: boolean;
        isRequired: boolean;
        displayName: string;
        buttons: ISwitchButton;
        onStateChange: (newState: string) => any;

        static $inject = [
            '$scope'
        ];

        $onInit() {
        }

        setState(newState: string) {
            this.model = newState;
            if (this.onStateChange) {
                this.onStateChange(newState);
            }
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoButtonSwitchComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/buttonSwitch/button-switch.component.html',
            controller: MeevoButtonSwitch,
            controllerAs: '$ctrl',
            bindings: {
                model: '=',
                isDisabled: '<ngDisabled',
                isRequired: '<ngRequired',
                displayName: '<',
                buttons: '<',
                onStateChange: '='
            }
        });
}
